var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"white_highlight--text",attrs:{"color":"secondary","disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.$t(_vm.label))+" "),(_vm.icon != '' && _vm.icon != null)?_c('v-icon',{staticStyle:{"color":"var(--v-white_highlight-base)"}},[_vm._v(_vm._s(_vm.icon))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }